<template>
    <div class="video-wrap" @click="showTitle = false">
        <vue-plyr ref="plyr" class="video" :options="{ controls: controls, clickToPlay: true }">
            <div data-plyr-provider="youtube" v-bind:data-plyr-embed-id="videoLink"></div>
        </vue-plyr>
        <div class="title-on-video" v-show="showTitle" @click="player.play()">
            <h1>{{post.title}}</h1>
        </div>
        <div class="time-author" v-show="showTitle">
            <p class="minor" @click="togglePopMess('Profiles are coming soon')">
                <span>/ </span>
                <span v-show="!delBtnVal">
                    {{post.author.firstname + ' ' + post.author.lastname}}
                </span>
                <span v-show="delBtnVal">
                    Your Post
                </span>
            </p>
            <!-- <p class="minor">
                <span>{{postedTime}}</span>
            </p> -->
            <router-link :to="linkURL">
                <p class="minor">
                    <span>Share</span>
                </p>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Video',
  props: [
      'userinfo',
      'videoLink',
      'post',
      'postedTime',
      'delBtnVal'
  ],
  data() {
      return {
          showTitle: true,
          linkURL: '/title/' + this.post.id,
      }
  },
  mounted () {
    // console.log(this.player)
  },
  computed: {
    player () { 
        return this.$refs.plyr.player 
    },
    controls () {
        return `<div class="plyr__controls">
              <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
                  <svg class="icon--pressed" role="presentation" viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                    <rect x="5" y="2" width="6" height="20"/><rect x="13" y="2" width="6" height="20"/>
                  </svg>
                  <svg class="icon--not-pressed" role="presentation" viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                    <polygon points="23 12 1 20.73 1 3.27 23 12 23 12"/>
                  </svg>
              </button>
              <div class="plyr__progress">
                  <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                  <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
                  <span role="tooltip" class="plyr__tooltip">00:00</span>
              </div>
              <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
              <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
              <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
                  <svg class="icon--pressed" role="presentation" viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                    <path d="M14.82,21.65V2.35L1.08,12Zm-2-3.85L4.56,12l8.26-5.8Z"/><polygon points="23.45 10.26 22.04 8.84 19.92 10.96 17.8 8.84 16.38 10.26 18.5 12.38 16.38 14.5 17.8 15.91 19.92 13.79 22.04 15.91 23.45 14.5 21.33 12.38 23.45 10.26"/>
                </svg>
                  <svg class="icon--not-pressed" role="presentation" viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                    <path d="M14.82,21.65V2.35L1.08,12Zm-2-3.85L4.56,12l8.26-5.8Z"/><rect x="19.92" y="6.38" width="2" height="12"/><rect x="16.92" y="9.38" width="2" height="6"/>
                  </svg>
              </button>
              <div class="plyr__volume">
                  <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
              </div>
              <button type="button" class="plyr__control" data-plyr="captions">
                  <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-captions-on"></use></svg>
                  <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-captions-off"></use></svg>
              </button>
              <button type="button" class="plyr__control" data-plyr="fullscreen">
                  <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
                  <svg class="icon--not-pressed" role="presentation" viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                    <polygon points="13 4 13 6 16.59 6 6 16.59 6 13 4 13 4 20 11 20 11 18 7.41 18 18 7.41 18 11 20 11 20 4 13 4"/>
                  </svg>
              </button>
          </div>
          `
    },
  },
  methods: {
    onPlay(data) {
        console.log("Video is playing", data)
    },    
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
  }
//   components: {
//       Video,
//   }

}
</script>
<style lang="scss">
.video-wrap {
    position: relative;
    .video {
        width: $col6;
        min-width: $col6;
    }
    .title-on-video, .time-author {
        display: none;
    }

    //VIDEO PLYR COLOR
    .plyr--full-ui input[type=range] {
        color: rgba(255, 0, 0, 1);
    }

    .plyr__control--overlaid {
        background: rgba(0, 0, 0, 1);
    }

    .plyr--video .plyr__control.plyr__tab-focus,
    .plyr--video .plyr__control:hover,
    .plyr--video .plyr__control[aria-expanded=true] {
        background: rgba(255, 0, 0, 1);
        border-radius: 0;
        svg {
            fill: #000;
        }
    }

    .plyr__control.plyr__tab-focus {
        box-shadow: 0 0 0 5px rgba(255,0,0, .5);
    }

    .plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]::before {
        background: rgba(255, 0, 0, 0.8);
    }

}
// MOBILE
@media #{$mobile} {    
    .video-wrap {
        .video {
            min-width: 100%;
        }
        .title-on-video {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .7);
            z-index: 1;
            // pointer-events: none;
            // touch-action: none;
            display: flex;
            align-items: center;
            h1 {
                color: white;
                margin: $main-margin-mobile;
                font-size: $big-h1-mobile;
            }
        }
        .time-author {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            display: flex;
            justify-content: space-between;
            width: 100%;
            
            p {
                margin: $main-margin-mobile;
                color: white;
                // opacity: .6;
            }
        }  

    }    
}
</style>
